module.exports = __webpack_public_path__ + "img/aiff.6e015092.png";